var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtons(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 30,
    viewBox: "0 0 65 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 65,
    height: 29,
    rx: 4,
    fill: "#1C1C1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 21.75C12.7143 19.15 12.4857 17.59 11.5714 16.55C10.6571 15.51 9.78571 15.25 7.5 15.25C9.78571 15.25 10.6571 14.99 11.5714 13.95C12.4857 12.91 12.7143 11.35 12.7143 8.75C12.7143 11.35 12.9429 12.91 13.8571 13.95C14.7714 14.99 16.1429 15.25 18.4286 15.25C16.1429 15.25 14.7714 15.51 13.8571 16.55C12.9429 17.59 12.7143 19.15 12.7143 21.75ZM20.7143 13.95C20.8286 13.17 20.6 12.52 20.2571 11.87C19.6857 11.48 19.1143 11.22 18.4286 11.35C19.1143 11.48 19.6857 11.22 20.2571 10.83C20.6 10.18 20.8286 9.53 20.7143 8.75C20.6 9.53 20.8286 10.18 21.1714 10.83C21.7429 11.22 22.3143 11.48 23 11.35C22.3143 11.22 21.7429 11.48 21.1714 11.87C20.8286 12.52 20.6 13.17 20.7143 13.95Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.714286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9521 19.75H32.3252V9.75586H37.9717V11.1367H33.9521V14.2539H37.7119V15.6279H33.9521V19.75ZM39.79 19.75V9.75586H41.4307V19.75H39.79ZM44.0693 19.75V9.75586H45.71V18.3555H49.9551V19.75H44.0693ZM51.6846 19.75V9.75586H53.3252V18.3555H57.5703V19.75H51.6846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtons);
export default __webpack_public_path__ + "static/media/Buttons.73dafc9d7985216f5085a93ae258be49.svg";
export { ForwardRef as ReactComponent };